import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.assign.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { throttle } from '@/utils/index';
import lottie from 'lottie-web';
import wanted from './animation/wanted.json';
import cancleWanted from './animation/unwanted.json';
import { cancelWish, addWish } from '@/apis/index';
import Drip from 'drip';
import axios from 'axios';
export default {
  props: {
    item: {
      type: Object,
      default: {}
    },
    index: {
      type: Number,
      default: 0
    },
    celebrityId: {
      type: Number,
      default: 0
    },
    hasWishedIds: {
      type: Array,
      default: []
    },
    locCity: {
      type: Object,
      default: {}
    },
    tour: {
      type: Object,
      default: {}
    }
  },
  mounted: function mounted() {
    this.toWant = throttle(this.toWant.bind(this), 500);
  },
  methods: {
    isWished: function isWished(id) {
      return this.hasWishedIds.includes(id);
    },
    registeAnimation: function registeAnimation(_ref) {
      var index = _ref.index,
        type = _ref.type;
      try {
        if (!type) {
          return;
        }
        var recommentWrapper = type === 'add' ? document.querySelector(".want-animate".concat(index)) : document.querySelector(".no-want-animate".concat(index));
        // name 唯一，存在想看和取消同时进行
        var name = type === 'add' ? "wanted".concat(index) : "no-wanted".concat(index);
        var animate = lottie.loadAnimation({
          container: recommentWrapper,
          renderer: 'svg',
          loop: false,
          autoplay: true,
          animationData: type === 'add' ? wanted : cancleWanted,
          name: name
        });
        // 动画进行中回调
        animate.addEventListener('enterFrame', function (value) {
          if (document.querySelector(".want".concat(index, " img"))) {
            document.querySelector(".want".concat(index, " img")).style.opacity = 0;
          }
        });
        // 动画完成回调
        animate.addEventListener('complete', function () {
          animate.destroy(name);
          if (document.querySelector(".want".concat(index, " img"))) {
            document.querySelector(".want".concat(index, " img")).style.opacity = 1;
          }
        });
      } catch (error) {
        this.$owlReportError('艺人主页许愿卡片-想看动画执行失败', error);
      }
    },
    // 点击想看
    toWant: function toWant(_ref2) {
      var item = _ref2.item,
        index = _ref2.index;
      if (!item) {
        return;
      }
      if (this.hasWishedIds.includes(item.cityId)) {
        this.onChangeWish({
          type: 'cancel',
          cityId: item.cityId,
          index: index
        });
      } else {
        this.onChangeWish({
          type: 'add',
          cityId: item.cityId,
          index: index
        });
      }
    },
    // 是否许愿 type: cancel, add
    onChangeWish: function onChangeWish(_ref3) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var cityId, type, index, payload, res, _ref4, success, error, _ref5, code, message, redirUrl;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              cityId = _ref3.cityId, type = _ref3.type, index = _ref3.index;
              _context.prev = 1;
              payload = {
                celebrityId: _this.celebrityId || 0,
                source: 1,
                //1演出艺人主页 2猫眼大搜
                tourId: (_this === null || _this === void 0 ? void 0 : _this.tour.tourId) || null,
                // 巡演ID, 巡演加场有，想看无，默认null
                wishCityId: cityId // 美团的城市id
              };

              _this.$loading();
              _context.next = 6;
              return axios.post(type === 'add' ? addWish : cancelWish, Object.assign({}, payload));
            case 6:
              res = _context.sent;
              _ref4 = (res === null || res === void 0 ? void 0 : res.data) || {}, success = _ref4.success, error = _ref4.error;
              _this.$loading.close();
              if (success) {
                if (type === 'add') {
                  _this.$toast('想看成功，已为您反馈心愿', {
                    wordWrap: false
                  });
                }
                _this.registeAnimation({
                  index: index,
                  type: type,
                  cityId: cityId
                });
                _this.$emit('onWishChange', {
                  cityId: cityId,
                  wishStatus: type === 'add' ? 1 : 0,
                  celebrityId: _this.celebrityId,
                  wishCardType: _this.item.wishCardType || 0 // wishCardType    0-许愿卡片  1-巡演卡片 ，默认值是0
                });
              } else {
                _this.$loading.close();
                _ref5 = error || {}, code = _ref5.code, message = _ref5.message;
                _this.$toast(message || '前方拥堵 请稍后重试');
                //需要登录
                if (code === 403) {
                  redirUrl = location.href;
                  if (_this.isShowCity) {
                    redirUrl += '&isAddCity=1';
                  }
                  Drip.login({
                    redirUrl: redirUrl
                  });
                }
              }
              _context.next = 17;
              break;
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](1);
              _this.$owlReportError('艺人主页许愿卡片-想看失败', _context.t0);
              _this.$loading.close();
              if (_context.t0) _this.$toast('服务器正忙');
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 12]]);
      }))();
    },
    getLocationText: function getLocationText(item) {
      var _this$locCity;
      //1:常规城市 2:筹备中城市
      if ((item === null || item === void 0 ? void 0 : item.wishCityType) === 2) {
        return '筹备中';
      }
      return Number((_this$locCity = this.locCity) === null || _this$locCity === void 0 ? void 0 : _this$locCity.id) === Number(item.cityId) ? '你在此处' : '附近城市';
    }
  }
};